const routes = {
  path: 'obu-yellow-pages',
  component: () => import('@/modules/obu-yellow-pages/index.vue'),
  children: [{
    path: '',
    name: 'obu-yellow-pages-list',
    component: () => import('@/modules/obu-yellow-pages/_components/ObuList.vue')
  },
  {
    path: 'create',
    name: 'obu-yellow-pages-create',
    component: () => import('@/modules/obu-yellow-pages/_components/ObuYellowPagesCreate.vue'),
  },
  {
    path: ':id',
    name: 'obu-details',
    component: () => import('@/modules/obu/_components/ObuDetails.vue'),
    children: [
      {
        path: 'base',
        name: 'obu-yellow-pages-details-base',
        component: () => import('@/modules/obu/_components/ObuDetailsBase.vue')
      },
      {
        path: 'contact',
        name: 'obu-details-contact',
        component: () => import('@/modules/obu/_components/Shared/ObuPlaceholder.vue')
      },
      {
        path: 'sites/:site?',
        name: 'obu-details-sites',
        component: () => import('@/modules/obu/_components/Sites/index.vue')
      },
      {
        path: 'media',
        name: 'obu-details-media',
        component: () => import('@/modules/obu/_components/Media/index.vue'),
        children: [
          {
            path: 'primary',
            name: 'obu-details-media-primary',
            component: () => import('@/modules/obu/_components/Media/ObuObjectMediaPrimary.vue')
          },
          {
            path: 'gallery/:gid?',
            name: 'obu-details-media-gallery',
            component: () => import('@/modules/obu/_components/Media/ObuObjectMediaGallery.vue')
          },
          {
            path: '3d',
            name: 'obu-details-media-3d',
            component: () => import('@/modules/obu/_components/Properties/ObuObjectPropertiesDetails3d.vue')
          },
        ]
      },
      {
        path: 'object-properties',
        name: 'obu-details-object-properties',
        component: () => import('@/modules/obu/_components/ObuObjectProperties.vue'),
        children: [
          {
            path: 'officially',
            name: 'obu-details-object-properties-officially',
            component: () => import('@/modules/obu/_components/Properties/ObuOfficially.vue')
          },
          {
            path: 'contact',
            name: 'obu-details-object-properties-contact',
            component: () => import('@/modules/obu/_components/Properties/ObuContact.vue')
          },
          {
            path: '3d',
            name: 'obu-details-object-properties-3d',
            component: () => import('@/modules/obu/_components/Properties/ObuObjectPropertiesDetails3d.vue')
          },
          {
            path: 'featured',
            name: 'obu-details-object-properties-featured',
            component: () => import('@/modules/obu/_components/Properties/ObuObjectPropertiesDetailsFeatured.vue')
          },
          {
            path: 'entity',
            name: 'obu-details-object-properties-entity',
            children: [
              {
                path: ':group',
                name: 'obu-details-object-properties-entity-main',
                component: () => import('@/modules/obu/_components/Properties/ObuObjectPropertiesDetailsDynamic.vue')
              }
            ]
          },
          {
            path: 'catering',
            name: 'obu-details-object-properties-catering',
            component: () => import('@/modules/obu/_components/Properties/ObuObjectPropertiesDetailsDynamic.vue'),
            children: [
              {
                path: ':group',
                name: 'obu-details-object-properties-catering-main',
                component: () => import('@/modules/obu/_components/Properties/ObuObjectPropertiesDetailsDynamic.vue')
              }
            ]
          },
          {
            path: 'service',
            name: 'obu-details-object-properties-service',
            children: [
              {
                path: 'holiday',
                name: 'obu-details-object-properties-entity-holiday-categories',
                component: () => import('@/modules/obu/_components/Properties/ObuObjectPropertiesDetailsHoliday.vue')
              },
              {
                path: ':group',
                name: 'obu-details-object-properties-service-main',
                component: () => import('@/modules/obu/_components/Properties/ObuObjectPropertiesDetailsDynamic.vue')
              }
            ]
          }
        ]
      },
      {
        path: 'neighborhood',
        name: 'obu-details-neighborhood',
        component: () => import('@/modules/obu/_components/ObuObjectNeighborhood.vue'),
        children: [
          {
            path: 'activities',
            name: 'obu-details-neighborhood-activities',
            component: () => import('@/modules/obu/_components/Neighborhood/ObuObjectNeighborhoodDynamic.vue'),
            children: [
              {
                path: ':group',
                name: 'obu-details-neighborhood-activities-main',
                component: () => import('@/modules/obu/_components/Neighborhood/ObuObjectNeighborhoodDynamic.vue')

              }
            ]
          },
          {
            path: 'closeby/:group',
            name: 'obu-details-neighborhood-closeby',
            component: () => import('@/modules/obu/_components/Neighborhood/ObuObjectNeighborhoodDistances.vue')
          },
          {
            path: 'pois',
            name: 'obu-details-neighborhood-pois',
            component: () => import('@/modules/obu/_components/Neighborhood/ObuObjectNeighborhoodPois.vue')
          }
        ]
      },
      {
        path: 'units',
        name: 'obu-details-units',
        component: () => import('@/modules/obu/_components/ObuUnits.vue'),
        children: [
          {
            path: 'units/:cid/edit',
            name: 'obu-details-units-units-edit',
            component: () => import('@/modules/obu/_components/Units/ObuUnitsUnitsModal.vue')
          },
          {
            path: 'units/add',
            name: 'obu-details-units-units-add',
            component: () => import('@/modules/obu/_components/Units/ObuUnitsUnitsModal.vue')
          },
          {
            path: 'categories',
            name: 'obu-details-units-categories',
            component: () => import('@/modules/obu/_components/UnitCategories/ObuUnitsCategories.vue')
          },
          {
            path: 'categories/:cid/edit',
            name: 'obu-details-units-categories-edit',
            component: () => import('@/modules/obu/_components/UnitCategories/ObuUnitsCategoriesModal.vue')
          },
          {
            path: 'categories/add',
            name: 'obu-details-units-categories-add',
            component: () => import('@/modules/obu/_components/UnitCategories/ObuUnitsCategoriesModal.vue')
          }
        ]
      },
      {
        path: 'rates',
        component: () => import('@/modules/obu/_components/ObuRates.vue'),
        children: [
          {
            path: ':year?',
            name: 'obu-details-rates',
            component: () => import('@/modules/obu/_components/Rates/ObuRatesList.vue'),
            children: [
              {
                path: ':sid/:parent/:parentId',
                name: 'obu-details-rates-edit',
                component: () => import('@/modules/obu/_components/Rates/ObuRatesEditModal.vue')
              }
            ]
          },
          {
            path: ':year/surcharges:',
            name: 'obu-details-prices-surcharges',
            component: () => import('@/modules/obu/_components/Surcharges/ObuPricesSurcharges.vue')
          },
          {
            path: ':year/surcharges/add',
            name: 'obu-details-prices-surcharges-add',
            component: () => import('@/modules/obu/_components/Surcharges/ObuPricesSurchargesModal.vue')
          },
          {
            path: ':year/surcharges/:sid/edit',
            name: 'obu-details-prices-surcharges-edit',
            component: () => import('@/modules/obu/_components/Surcharges/ObuPricesSurchargesModal.vue')
          }
        ]
      }
    ]
  }]
}

export default routes
